






















import { Component, Vue, Prop } from "vue-property-decorator";
import { statusProject } from "@/status";

interface ProjectStatus {
  id: number;
  statusProject: number;
  colorName:
    | {
        name: string;
        color: string;
      }
    | string;
}

@Component({})
export default class ProjectBreadCrumbs extends Vue {
  @Prop({ default: [] }) project!: ProjectStatus;

  private status = statusProject;

  get breadcrumbColor() {
    if (typeof this.project.colorName === "object") {
      return this.project.colorName.color;
    }

    return this.project.colorName;
  }

  get breadStatusName() {
    if (typeof this.project.colorName === "object") {
      return this.project.colorName.name;
    }

    return null;
  }

  get typeOfColorIsObject() {
    return typeof this.project.colorName === "object";
  }
}
